export default __webpack_public_path__ + "static/media/green2.95f829dc.jpg";